import { prematchHref } from '../route';

const PICKED = 'forq.phone.line-picked';

export function rememberLinePick(): void {
  try {
    sessionStorage.setItem(PICKED, '1');
  } catch {
    /* */
  }
}

/** Только голый /app. Явный /app/live не уводим. */
export function maybeRedirectPrematch(): void {
  const p = location.pathname.replace(/\/+$/, '');
  if (!/(?:^|\/)app$/.test(p)) return;
  if (new URLSearchParams(location.search).get('line') === 'live') return;
  try {
    if (sessionStorage.getItem(PICKED) === '1') return;
  } catch {
    /* */
  }
  rememberLinePick();
  location.replace(`${prematchHref()}${location.search}${location.hash}`);
}
